import axios from 'lib/axios'

export const getCustomCategory = () => {
  return axios.get('admin/custom')
}

export const postOvertimePayroll = ({ time_id, employee_id, data }) => {
  return axios.post(`admin/payroll/${time_id}/employee/${employee_id}/overtime`, data)
}

export const postSubmitPayroll = ({ time_id, employee_id, data }) => {
  return axios.post(`admin/payroll/${time_id}/employee/${employee_id}/calculate`, data)
}

export const postCalculatePayroll = ({ time_id, employee_id, data }) => {
  return axios.post(`admin/payroll/${time_id}/employee/${employee_id}/adjust`, data)
}

export const postEditStatutoryContribution = ({ time_id, employee_id, data }) => {
  return axios.post(`admin/payroll/${time_id}/employees/${employee_id}/statutory/edit`, data)
}
